export const onboardingSteps = {
    steps: {
        1: {
            id: "1",
            page: "/signUpConfirmation",
        },
        2: {
            id: "2",
            page: "/nameAndPassword",
        },
        3: {
            id: "3",
            page: "/inviteYourTeam",
        },
        4: {
            id: "4",
            page: "/addProjects",
        },
        5: {
            id: "5",
            page: "/tutorial",
        },
        done: {
            id: "done",
            page: "/dashboard",
        },
        "team-onboarding": {
            id: "team-onboarding",
            page: "/nameAndPassword",
        },
    },
    sort: ["1", "2", "3", "4", "5", "done"],
}

export const getNextOnboardingPage = nextOnboardingStep =>
    onboardingSteps.steps[nextOnboardingStep].page

export const getNextOnboardingStep = onboardingStep => {
    if (onboardingStep === "done") {
        return "done"
    }

    if (onboardingStep === "team-onboarding") {
        return "5"
    }

    // if there is no onboarding step, use the first step as current step
    const step = onboardingStep || onboardingSteps.sort[0]
    const nextIndex = onboardingSteps.sort.indexOf(step) + 1
    const nextStep = onboardingSteps.sort[nextIndex]

    return nextStep
}



// WEBPACK FOOTER //
// ./src/util/profile_utils.js